import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '@/shared/api';
import { type TypeTimeoutConfig } from '@intone/shared/types';

export function useTimeoutConfigs(configId: number) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['timeout-configs', configId],
    queryFn: async () => {
      return apiClient<TypeTimeoutConfig[]>(`/timeout-configs/${configId}`);
    },
  });
}

/**
 * Hook to save a timeout config (create new or update existing)
 */
export function useSaveTimeoutConfig() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: {
      id?: number;
      name: string;
      first_turn_timeout: number;
      other_turns_timeout: number;
      confirmation_timeout: number;
      agentId: string;
    }) => {
      return apiClient<TypeTimeoutConfig>('/timeout-configs/save', {
        method: 'POST',
        body: JSON.stringify(config),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['timeout-configs'] });
    },
  });
}